// Utils & misc
import cn from '../../../utils/cn';

// Style
import style from './Badge.module.css';

/**
 * Badge component - Displays a number in a circular badge
 * @param {object} params
 * @param {number} params.value - Number to display in the badge
 * @param {'primary' | 'neutral'} [params.theme = 'primary'] - Theme of the badge (primary, neutral)
 * @param {string} [params.className] - Additional CSS classes
 * @returns {JSX.Element} Badge component
 */
function Badge({
  value,
  theme = 'primary',
  className,
}) {
  return (
    <div
      className={cn([style.badge, style[theme], ...(className ? [className] : [])])}
    >
      {value > 99 ? '99' : value}
    </div>
  );
}

export default Badge;
